// Shared "engage sixZero as your buyer's agent" acknowledgement — gates
// scheduling, comps analysis, and Ask Cisero chat behind a one-time
// confirmation. Free tier stays view + disclosures only, per the buyer
// tiering requirement. Lightweight agreement-confirmation, not real
// e-signature — same spirit as the seller flow's ownership-confirm step.
export default function AgentGateModal({ label, onAccept, onClose, busy }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(21,45,33,0.55)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 18, padding: 28, width: "100%", maxWidth: 420, boxShadow: "0 16px 48px rgba(0,0,0,0.2)" }}>
        <div style={{ fontSize: 26, marginBottom: 10 }}>🤝</div>
        <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, fontWeight: 700, color: "#152d21", marginBottom: 8 }}>
          Let sixZero be your buyer's agent
        </div>
        <p style={{ fontSize: 13, color: "#5b7365", lineHeight: 1.7, marginBottom: 14 }}>
          Viewing homes and disclosures is always free. To {label}, engage sixZero as your buyer's agent — no cost to you, we're paid by the seller's side at close like any buyer's agent.
        </p>
        <ul style={{ fontSize: 12, color: "#3d4f45", lineHeight: 2, margin: "0 0 18px", paddingLeft: 18 }}>
          <li>Schedule showings with calendar invites</li>
          <li>AI comps analysis on any listing</li>
          <li>Ask Cisero — deal evaluation &amp; negotiation help</li>
          <li>Talk to a real sixZero agent anytime</li>
        </ul>
        <button
          disabled={busy}
          onClick={onAccept}
          style={{ width: "100%", background: "#2d7a62", color: "#fff", border: "none", borderRadius: 10, padding: "13px", fontSize: 14, fontWeight: 700, cursor: busy ? "default" : "pointer", fontFamily: "'Outfit',sans-serif", marginBottom: 8 }}
        >
          {busy ? "…" : "Yes, represent me →"}
        </button>
        <button onClick={onClose} style={{ width: "100%", background: "none", border: "none", color: "#9bbfb2", fontSize: 12, cursor: "pointer", padding: 6 }}>Not now</button>
      </div>
    </div>
  );
}
